import styled from "styled-components";

import Base from "./Base";

const BadgeSmallMonza = styled(Base).attrs({ className: "badge--monza" })`
  background: ${props => props.theme.colors.monza};
`;

BadgeSmallMonza.displayName = "BadgeSmallMonza";

export default BadgeSmallMonza;
